import { DatePipe } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';

import { ToastrService } from 'ngx-toastr';
import { ComponentCanDeactivate } from 'src/app/components/PendingChangesGuard';

import { ConfirmationDialogService } from 'src/app/components/confirmation-dialog/confirmation-dialog.service';
import { AddrawmaterialComponent } from 'src/app/components/rawmaterial/addrawmaterial/addrawmaterial.component';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';


@Component({
  selector: 'app-addxfer',
  templateUrl: './addxfer.component.html',
  styleUrls: ['./addxfer.component.css']
})
export class AddxferComponent implements OnInit , ComponentCanDeactivate {

  @ViewChild('Selecter', { static: false }) ngselect: NgSelectComponent;

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;
  ischeck: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  isload: boolean = true;

  israwmaterialaddmode: boolean = false;
  isxfertypeaddmode: boolean = false;

  rtnform: string = "";
  errtxt: any = "";

  //Edit Get Values
  xfermainColl: any = [];

  xferBO: any = {}
  tocompanyColl: any = [];

  xferdetailscoll: any = [];

  ismanualclose: boolean;

  qtytotal: number = 0;
  unitpricetotal: number = 0;
  subtotal: number = 0;


  discounttype: string = "";

  productfindColl: any;
  taxColl: any;
  uomColl:any;
  rawmaterialColl: any;
  isLoadingResult: boolean;

  filterpaymentmodeid: number = 0;

  xferform = new FormGroup({
    xferid: new FormControl(0),
    xferno: new FormControl('', Validators.required),
    xferdate: new FormControl(null, Validators.required),
    refno: new FormControl(''),
    grandtotal: new FormControl(null),
    descr: new FormControl(''),
    tocompanyid: new FormControl(null, Validators.required),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Transfer";

  gridfocusrow: number = -1;

  @Input() xferid: number = 0
  @Input() filtertocompanyid: number = null;
  @Input() filterfromdate: any = null;
  @Input() filtertodate: any = null;
  @Input() formmode: String = "";


  @Output() emitData = new EventEmitter();

  currencyMask:any="";

  constructor(private appService: DhukanDataService, private activeModal: NgbActiveModal, private route: ActivatedRoute,
    private productFindService: NgbModal, private confirmationDialogService: ConfirmationDialogService,
    public router: Router, private toastr: ToastrService, public loginService: LoginDataService, private datePipe: DatePipe) {

      this.currencyMask=this.loginService.fngetDecimalPlaces()
      
    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }

        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.xferform.reset();
      this.fnInitializeForm();

      if (this.xferid > 0) {
        this.fngetAdj();
      }
      else {
        this.fnSetFirstRowItem()
      }
      this.fngetToCompany();
      this.fnGetRawmaterial();
      this.fnGetUom()
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit() {
    //  this.loginService.fnSetFirstControlFocusLookup(this.ngselect);


  }





  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.xferid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }
    this.israwmaterialaddmode = this.loginService.fnCheckUserRoleAction("Rawmaterial", 'CREATE')
    this.isxfertypeaddmode = this.loginService.fnCheckUserRoleAction("Adjtype", 'CREATE')

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeForm() {
    this.xferform.setValue({
      xferid: 0,
      xferno: 'NEW',
      xferdate: new Date(),
      grandtotal: null,
      descr: null,
      tocompanyid: null,
      refno: '',
      inactive: false,
    })
  }



  fngetToCompany() {
    var data = {
      
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getCompanyXfer(data)
      .subscribe(
        (res) => {
          this.tocompanyColl = res.json().result;
        
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnGetUom() {
    this.isLoadingResult = true;

    var data = {
      'uomid': 0,
      'organizationid': this.loginService.fnGetOrganizationId(),
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getUom(data)
      .subscribe(
        (res) => {
          this.uomColl = res.json().result;


          this.isLoadingResult = false;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }



  //Get 
  fngetAdj() {

    var data = {
      'xferid': this.xferid,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getXfer(data)
      .subscribe(
        (res) => {
          var result = res.json().result;
         
          this.xfermainColl = result[0];

          var editdata = this.xfermainColl[0];
          this.xferBO = editdata;
          this.fnEditMode(editdata);

          this.xferdetailscoll = result[1];
          //console.log(this.xferdetailscoll)

          if (this.xferdetailscoll.length === 0) {
            this.fnSetFirstRowItem()
          }
          this.fnCalcDetails();
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnValidation() {
    var _ischeck = false;
    var _detailscheck = false;
    var _uomcheck = false;

    for (let row of this.xferdetailscoll) {
      if (row.rawmaterialid > 0) {
        _detailscheck = true;       
        if(this.aaNumber(row.uomid)===0){
          _uomcheck=true
        }
      }
    }

    if (!_detailscheck) {
      this.errtxt = "Transfer Details cannot be empty"
      this.xferform.controls['inactive'].setErrors({ 'notfound': true });
      _ischeck = true;
    }
    if (!_ischeck) {
      if (_uomcheck) {
      this.errtxt = "Unit cannot be empty"
      this.xferform.controls['inactive'].setErrors({ 'notfound': true });
      _ischeck = true;
    }
  }
    
    if (!_ischeck) {
      for (let row of this.xferdetailscoll) {

        if (row.rawmaterialid > 0 && this.loginService.fnCheckZeroDetcimal(row.qty) === 0) {
          this.errtxt = "Quantity is cannot be empty"
          this.xferform.controls['inactive'].setErrors({ 'notfound': true });
          _ischeck = true;
        }

      }
    }
    return _ischeck;

  }

  fnResetValidation() {

    if (this.xferform.get('inactive')) {
      this.xferform.controls['inactive'].setErrors(null);
    }

  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;

      this.fnResetValidation()
      //Validate

      if (this.xferform.valid) {

        if (this.fnValidation()) {

          return false
        }


        this.saveloading = true;



        //Check
        var data = {
          'xferid': this.xferid,
          'xferno': this.xferform.get('xferno').value,
          'xferdate': this.fnFormatDatetime(this.xferform.get('xferdate').value),
          'grandtotal': this.xferform.get('grandtotal').value,
          'descr': this.xferform.get('descr').value,
          'tocompanyid': this.xferform.get('tocompanyid').value,
          'refno': this.xferform.get('refno').value,
          'inactive': this.xferform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
          'xferdetailscoll': this.xferdetailscoll,
        }

        if (this.xferform.get('xferid').value > 0) {

          this.fnSetAdj(data);
        }
        else {

          this.fnInsertAdj(data);
        }

      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }

  }

  //Insert
  fnInsertAdj(data) {

    this.appService.fnInsertXfer(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status == 200) {
          this.toastr.success('', "The new Adjustment has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.xferno);

          var _result = res.json().result;
          if (_result.length > 0) {
            this.fnEditFormEdit(_result[0].xferid);
          }

        } else {
          this.toastr.error('Error', res.json().err_message);
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetAdj(data) {

    this.appService.fnSetXfer(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status == 200) {
          this.toastr.success('', "The Adjustment has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.xferid, data.xferno);

          this.fnEditFormEdit(this.xferid);
        } else {
          this.toastr.error('Error', res.json().err_message);
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }


  private fnEditMode(deptBO) {

    deptBO.xferdate = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.xferdate));


    this.xferform.setValue({

      xferid: deptBO.xferid,
      xferno: deptBO.xferno,
      xferdate: deptBO.xferdate,
      grandtotal: deptBO.grandtotal,
      descr: deptBO.descr,
      tocompanyid: deptBO.tocompanyid,
      refno: deptBO.refno,
      inactive: deptBO.inactive,

    });




    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = false;

    if (this.formmode === 'EDIT') {
      this.iseditmode = true;
    }
    else {
      this.isviewmode = true;
    }
  }


  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }




  fnEditFormEdit(id) {

    this.xferid = id;
    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;


    //this.ngOnInit();

    this.ismanualclose = true;
    this.fnCloseForm();

  }

  //Close
  async fnCloseForm() {

    try {

      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;


      this.emitData.emit("");
      this.activeModal.close(true);

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  @HostListener('window:beforeunload')
  canDeactivate(): any {

    if (this.ismanualclose || this.isviewmode) {
      return true;
    }
    else {
      return false;
    }
  }

  //Details

  fnGetRawmaterial() {
    this.isLoadingResult = true;

    var data = {
      'rawmaterialid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getRawmaterial(data)
      .subscribe(
        (res) => {
          this.rawmaterialColl = res.json().result;

          this.isLoadingResult = false;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fnReLoadRawmaterial(index) {


    var data = {
      'rawmaterialid': 0,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getRawmaterial(data)
      .subscribe(
        (res) => {
          this.fnChangeRawmaterial(index)
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnCalcDetails() {

    for (let row of this.xferdetailscoll) {
      row.subtotal = row.qty * row.unitprice;
      this.subtotal = this.subtotal + Number(row.subtotal)



    }
    this.fnCalcsSummaryTotal()
  }




  fnCalcsSummaryTotal() {
    this.qtytotal = 0;
    this.unitpricetotal = 0;
    this.subtotal = 0;


    for (let row of this.xferdetailscoll) {
      this.qtytotal = Number(this.fnConvertDecimal(this.qtytotal)) + Number(this.fnConvertDecimal(row.qty))
      this.unitpricetotal = Number(this.fnConvertDecimal(this.unitpricetotal)) + row.unitprice
      this.subtotal = Number(this.fnConvertDecimal(this.subtotal)) + row.subtotal

    }
    this.xferform.patchValue({ grandtotal: this.subtotal })
  }




  fnDeletexferConfirm(index) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete details?')
        .then((confirmed) => {
          if (confirmed) {
            this.xferdetailscoll.splice(index, 1)
            if (this.xferdetailscoll.length === 0) {
              this.fnSetFirstRowItem()
            }
            this.fnCalcDetails()
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  fnChangeRawmaterial(index) {

    var _prodname = "", _unitprice = 0,_uomid=0;

    for (let abo of this.rawmaterialColl) {
      if (this.xferdetailscoll[index].rawmaterialid === abo.rawmaterialid) {
        _prodname = abo.rawmaterialname;
        _unitprice = abo.purchaseprice;
        _uomid=abo.purchaseuomid

      }
    }
    this.xferdetailscoll[index].rawmaterialname = _prodname;
    this.xferdetailscoll[index].unitprice = _unitprice;
    this.xferdetailscoll[index].uomid=_uomid
    this.fnChangeUom(index)

  }


  fnSetFirstRowItem() {
    if (this.xferdetailscoll.length > 0) {
      if (!this.xferdetailscoll[this.xferdetailscoll.length - 1].rawmaterialid) {
        return
      }
    }

    var data = {
      xferdetailsid: 0,
      xferid: 0,
      rawmaterialid: null,
      rawmaterialname: '',
      qty: 0,
      unitprice: 0,
      subtotal: 0,

    }

    this.xferdetailscoll.push(data)

  }
  fnGetFirstRowItem() {

    var data = {
      xferdetailsid:null,
      xferid: null,
      rawmaterialid: null,
      rawmaterialname: '',
      uomid: null,
      uomidname: '',
      qty: null,
      unitprice:null,
      subtotal:null,     
      taxid: null,
      taxname: '',
      taxrate: null,
      taxamt: null,
      cgsttaxrate: 0,
      cgsttaxamt: 0,
      sgsttaxrate: 0,
      sgsttaxamt: 0,
      igsttaxrate: 0,
      igsttaxamt: 0,
      taxable: 0,
      nettotal:null
    }

    return data;

  }

  
  fnChangeUom(index) {

    var  _uomid = null, _uomname = null;

    for (let abo of this.uomColl) {
      if (this.xferdetailscoll[index].uomid === abo.uomid) {
        _uomname = abo.uomname;
        _uomid = abo.uomid;
       
      }
    }
    this.xferdetailscoll[index].uomname = _uomname;
    this.xferdetailscoll[index].uomid = _uomid;

  }



  //Focus
  fnFocusChangeGridRow(index) {
    this.gridfocusrow = index

  }

  fnSetNextFocus(index) {

    if (this.xferdetailscoll.length > 0) {

      if (this.xferdetailscoll.length > index + 1) {
        this.gridfocusrow = index + 1
      }
    }


  }


  //Addxfertype
 
  //AddProduct
  private fnAddRawmaterial(index) {

    const modalRef = this.productFindService.open(AddrawmaterialComponent, { size: <any>'xxl' });
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fnGetRawmaterial();

      if (receivedEntry > 0) {
        this.xferdetailscoll[index].rawmaterialid = receivedEntry
      }
      this.fnReLoadRawmaterial(index);

    });
  }
  //Print
  // private fnPrintxfer() {

  //   const modalRef = this.productFindService.open(PrintComponent, { size: <any>'l', backdrop: 'static' });
  //   modalRef.componentInstance.trxid = this.xferid;
  //   modalRef.componentInstance.doctype = this.formname;

  //   modalRef.componentInstance.emitData.subscribe((receivedEntry) => {



  //   });

  // }
  //Print
  // private fnGldetails() {

  //   const modalRef = this.productFindService.open(GldetailscommonComponent, { size: <any>'l', backdrop: 'static' });
  //   modalRef.componentInstance.trxid = this.xferid;
  //   modalRef.componentInstance.doctype = this.formname;

  //   modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

  //   });

  // }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId()

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  fnConvertDecimal(value) {
    if (!value) {
      return 0
    }
    else {
      return value
    }

  }


  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }

 
  
  fnPostingConfirm(type) {
    this.confirmationDialogService.confirm('Confirm..', 'Do you  want to ' + type + ' Xfer?')
      .then((confirmed) => {
        if (confirmed) {
          if (type === 'Post') {
            this.fnPosting()
          }
          else if (type === 'UnPost') {
            this.fnUnPosting()
          }

        }
      }
      );
  }


  fnPosting() {
    var data = {
      trxid: this.xferid,
      doctype: 'TRANSFER',
      postingtype: 'MANUAL',
      modifiedby: this.loginService.fnGetModUserId()

    }
    this.appService.fnInsertPostings(data)
      .subscribe(
        (res) => {
         
          if (res.json().status === 200) {
        
            this.fnEditFormEdit(this.xferid);
          }
          else {
            this.toastr.error('Error', res.json().err_message);
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnUnPosting() {
    var data = {
      trxid: this.xferid,
      doctype: 'TRANSFER',
      postingtype: 'MANUAL',
      modifiedby: this.loginService.fnGetModUserId()

    }
    this.appService.fnInsertUnPostings(data)
      .subscribe(
        (res) => {
          
          if (res.json().status === 200) {
          
            var result=res.json().result;
           
            if(result.length>0){
         
              if(result[0].checkresult==='DONE'){
                this.fnEditFormEdit(this.xferid);
              }
              else{
                this.toastr.error('Error', result[0].checkresultmsg);
              }
            }
           
          }
          else {
            this.toastr.error('Error', res.json().err_message);
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  
  fnEnableEditBtn() {
    if(this.xferBO.iscancelled===1){
      return false;
    }
    else if (this.xferBO.isposted === 1) {
      return false;
    }
    else {
      return true;
    }
  }

  fnEnablePostBtn() {
    if(this.xferBO.iscancelled===1){
      return false;
    }
    else  if (this.xferBO.isposted === 1) {
      return false;
    }
    else {
      return true;
    }
  }


  
  fnEnableUnPostBtn() {
    if (this.xferBO.isposted === 1) {
      return true;
    }
    else {
      return false;
    }
    
  }
  aaNumber(total) {

    if (isNaN(total) || total === undefined || total === null) {
      return Number(0)
    }
    else {
      return Number.parseFloat(Number(total).toFixed(2))
    }
  }

  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }







}
